interface IPhoneNumberProps {
  value: string
}

const PhoneNumber = (props: IPhoneNumberProps) => {
  const tel = props.value
  let number = ""

  if (tel !== null) {
    let value = tel.replaceAll(/[A-Za-z~`!@#$%^&*()_=+\\';:"?>.<,-\s]/g, "")

    switch (tel.length) {
      case 9:
        number =
          value.substring(0, 2) +
          " " +
          value.substring(2, 3) +
          " " +
          value.substring(3, 6) +
          " " +
          value.substring(6, 9)
        break
      case 10:
        number =
          value.substring(0, 2) +
          " " +
          value.substring(2, 4) +
          " " +
          value.substring(4, 7) +
          " " +
          value.substring(7, 10)
        break
      case 11:
        if (value.startsWith("06")) {
          number =
            value.substring(0, 2) +
            " " +
            value.substring(2, 4) +
            " " +
            value.substring(4, 11)
        } else {
          number =
            "+" +
            value.substring(0, 2) +
            " " +
            value.substring(2, 4) +
            " " +
            value.substring(4, 11)
        }
        break
      default:
        number = tel
        break
    }
  }

  return <>{number}</>
}

export default PhoneNumber
